import React from 'react';
import { FormattedDate, FormattedNumber, injectIntl } from 'react-intl';
import { Spin } from 'antd';
import { useBreakpoint } from '../../../../hooks/useBreakpoint';
import { ShowIf } from '../../../shared/components';
import CurrencyFormat from '../../../shared/components/dataDisplay/CurrencyFormat';

function PurchaseResume({
  encargos, intl, encargo: { fecha_emision, fecha_ultimo_pago },
}:any) {
  const breakPoint = useBreakpoint();
  let sumatotales = 0;
  let sumapendientes = 0;
  encargos.forEach(({
    total, total_pendiente,
  }:any) => {
    sumatotales += total ? parseFloat(total) : 0;
    sumapendientes += total_pendiente ? parseFloat(total_pendiente) : 0;
  });
  return (
    <div className={`${breakPoint.isDesktop ? 'marginL16' : ''} flexRow spaceBetween purchaseResumeBox`}>
      <div className="flexCol spaceBetween">
        <span className="purchaseDate">
          {intl.formatMessage({ id: 'pacientes.client_file.first_purchase' })}
          {fecha_emision}
          <ShowIf condition={fecha_ultimo_pago}>
            -
            {' '}
            {intl.formatMessage({ id: 'pacientes.client_file.last_purchase' })}
            {fecha_ultimo_pago}
          </ShowIf>
        </span>
        <span className="resumeTitle" style={{ fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.65)' }}>
          {intl.formatMessage({ id: 'pacientes.client_file.purchase_resume' })}
        </span>
      </div>
      <div className="flexRow rightBox">
        <div className="flexColumn spaceBetween alignRight">
          <span>{intl.formatMessage({ id: 'pacientes.client_file.total' })}</span>
          <span className="price"><CurrencyFormat value={sumatotales.toFixed(2) || 0} /></span>
        </div>
        <div className="flexColumn spaceBetween alignRight lastBox">
          <span>{intl.formatMessage({ id: 'pacientes.client_file.pending' })}</span>
          <span className="price pending"><CurrencyFormat value={sumapendientes.toFixed(2)} /></span>
        </div>
      </div>
    </div>
  );
}

export default injectIntl(PurchaseResume);
